import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function ContactUs() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });
    
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");

        const formPayload = new FormData();
        formPayload.append("name", formData.name);
        formPayload.append("email", formData.email);
        formPayload.append("phone", formData.phone);
        formPayload.append("subject", formData.subject);
        formPayload.append("message", formData.message);

        try {
            const response = await fetch("https://wamglamz.com/wambackend/send_contact_us.php", {
                method: "POST",
                body: formPayload,
            });

            if (response.ok) {
                setStatus("Message sent successfully!");
                setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
            } else {
                setStatus("Failed to send message. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setStatus("An error occurred. Please try again later.");
        }
    };

    return (
        <div className="font-sans text-gray-800 bg-[#FAFCFF] flex flex-col min-h-screen">
            <Navbar />

            <main className="flex-grow flex flex-col items-center w-full">
                <div className="w-full border-b border-gray-200 bg-white shadow-sm">
                    <div className="max-w-[1280px] mx-auto px-6 py-8 text-center">
                        <h1 className="text-3xl md:text-4xl text-[#005AAC] font-bold tracking-tight">
                            Contact Us
                        </h1>
                    </div>
                </div>

                <div className="w-full max-w-[1100px] mx-auto px-6 md:px-12 py-16 md:py-20 flex flex-col md:flex-row gap-16 md:gap-20">
                    <div className="flex-1 text-gray-700">
                        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
                            Get in Touch
                        </h2>
                        <p className="mb-10 leading-relaxed text-gray-500 text-[16px]">
                            We'd love to hear from you! Whether you have questions, feedback, or need support, our team is here to help.
                        </p>

                        <div className="space-y-8 text-[15px]">
                            <div className="flex items-start gap-4">
                                <div className="mt-1 bg-blue-50 p-2.5 rounded-full text-[#1A73E8]">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-0.5">Email</h3>
                                    <p className="text-gray-600">wamglammz@gmail.com</p>
                                </div>
                            </div>
                            
                            <div className="flex items-start gap-4">
                                <div className="mt-1 bg-blue-50 p-2.5 rounded-full text-[#1A73E8]">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-0.5">Phone</h3>
                                    <p className="text-gray-600">+1 (971) 245-9544</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="mt-1 bg-blue-50 p-2.5 rounded-full text-[#1A73E8]">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-0.5">Business Hours</h3>
                                    <p className="text-gray-600">Monday – Friday: 9:00 AM – 6:00 PM</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="mt-1 bg-blue-50 p-2.5 rounded-full text-[#1A73E8]">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-0.5">Location</h3>
                                    <p className="text-gray-600">Serving clients and professionals worldwide</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex-1">
                        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
                            <h2 className="text-2xl font-bold mb-6 text-gray-900">
                                Send Us a Message
                            </h2>
                            
                            <form className="space-y-5" onSubmit={handleSubmit}>
                                <div>
                                    <label className="block text-[13px] font-semibold text-gray-700 mb-1.5">Full Name</label>
                                    <input 
                                        type="text" 
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:bg-white focus:outline-none focus:border-[#1A73E8] focus:ring-2 focus:ring-blue-100 transition-all duration-200"
                                        placeholder="John Doe"
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-[13px] font-semibold text-gray-700 mb-1.5">Email Address</label>
                                    <input 
                                        type="email" 
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:bg-white focus:outline-none focus:border-[#1A73E8] focus:ring-2 focus:ring-blue-100 transition-all duration-200"
                                        placeholder="john@example.com"
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-[13px] font-semibold text-gray-700 mb-1.5">Phone No.</label>
                                    <input 
                                        type="tel" 
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:bg-white focus:outline-none focus:border-[#1A73E8] focus:ring-2 focus:ring-blue-100 transition-all duration-200"
                                        placeholder="+1 (555) 000-0000"
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-[13px] font-semibold text-gray-700 mb-1.5">Subject</label>
                                    <input 
                                        type="text" 
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-gray-800 focus:bg-white focus:outline-none focus:border-[#1A73E8] focus:ring-2 focus:ring-blue-100 transition-all duration-200"
                                        placeholder="How can we help you?"
                                    />
                                </div>
                                
                                <div>
                                    <label className="block text-[13px] font-semibold text-gray-700 mb-1.5">Message</label>
                                    <textarea 
                                        rows="5"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-gray-800 focus:bg-white focus:outline-none focus:border-[#1A73E8] focus:ring-2 focus:ring-blue-100 transition-all duration-200 resize-y"
                                        placeholder="Write your message here..."
                                    ></textarea>
                                </div>

                                {status && (
                                    <div className={`text-sm font-medium ${
                                        status.includes("successfully") ? "text-green-600" :
                                        status.includes("Sending") ? "text-blue-600" :
                                        "text-red-600"
                                    }`}>
                                        {status}
                                    </div>
                                )}

                                <div className="pt-4 flex justify-center">
                                    <button 
                                        type="submit" 
                                        disabled={status === "Sending..."}
                                        className="bg-[#242A69] hover:bg-[#1A1F52] hover:-translate-y-0.5 disabled:opacity-75 disabled:hover:translate-y-0 text-white font-semibold py-3 px-12 rounded-full transition-all duration-200 shadow-md hover:shadow-lg w-full md:w-auto"
                                    >
                                        {status === "Sending..." ? "Sending..." : "Submit Message"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    
                </div>
            </main>

            <Footer />
        </div>
    );
}